import React from 'react';
import './Clients.css';

const clients = [
  {
    name: 'MNS Group',
    logo: '/dts-assets/clients/mns-group.png',
  },
  {
    name: 'Dollar Chemical Company',
    logo: '/dts-assets/clients/dollar-chemical.png',
  },
  {
    name: 'HI-TECH',
    logo: '/dts-assets/clients/hi-tech.png',
  },
  {
    name: 'Orange U',
    logo: '/dts-assets/clients/orange-u.png',
  },
  {
    name: 'Sindh Insurance',
    logo: '/dts-assets/clients/sindh-insurance.png',
  },
  {
    name: 'Askari General Insurance',
    logo: '/dts-assets/clients/askari-insurance.png',
  },
  {
    name: 'Xtreme',
    logo: '/dts-assets/clients/xtreme.png',
  },
  {
    name: 'DRC',
    logo: '/dts-assets/clients/drc.png',
  },
  {
    name: 'Afeef Zara Packages Ltd.',
    logo: '/dts-assets/clients/afeef-zara.png',
  },
  {
    name: 'W Pak Land',
    logo: '/dts-assets/clients/w-pak-land.png',
  },
];

const ClientLogo = ({ client }) => (
  <div className="client-logo-card">
    <img src={client.logo} alt={client.name} loading="lazy" />
  </div>
);

const Clients = () => (
  <section className="clients-section section">
    <div className="clients-bg" />

    <div className="container">
      <div className="section-header reveal">
        <span className="section-label">Our Clients</span>
        <h2>
          Trusted by Our
          <br />
          <em>Business Partners</em>
        </h2>
        <div className="divider" />
        <p>
          Dynamic Tracking Solutions proudly serves businesses across tracking,
          fleet monitoring, insurance, logistics, packaging, and security operations.
        </p>
      </div>
    </div>

    <div className="client-logo-marquee reveal">
      <div className="client-logo-track">
        {[...clients, ...clients].map((client, index) => (
          <ClientLogo client={client} key={`${client.name}-${index}`} />
        ))}
      </div>
    </div>

    <div className="client-logo-marquee client-logo-marquee-reverse reveal">
      <div className="client-logo-track reverse">
        {[...clients.slice().reverse(), ...clients.slice().reverse()].map((client, index) => (
          <ClientLogo client={client} key={`${client.name}-reverse-${index}`} />
        ))}
      </div>
    </div>
  </section>
);

export default Clients;